import {InjectionToken} from "@angular/core";
import {ILanguageStateService} from "@zaeper/localization-lib";

export const languageStateServiceInjectionToken: InjectionToken<ILanguageStateService> = new InjectionToken<ILanguageStateService>("digital-signage-developer-dashboard.LanguageStateService");
